"use strict";
import EventEmitter from 'eventemitter2';
import Browser from '../util/browser'

class VideoCanvas extends EventEmitter{
	constructor($con){
		super();		
		this.$con = $con;
		this.$canvas;
		this.isPlay = false;
	}

	init(){
		let src = this.$con.data('src');
		var vW = this.$con.data('width');
		var vH = this.$con.data('height');
		
		let h = '';
		h += '<canvas width="'+vW+'" height="'+vH+'"></canvas>';
		this.$con.append(h);

		this.$canvas = this.$con.find('canvas');
		
		this.video = document.createElement('video');
		this.video.style.display = 'none';
		document.body.appendChild(this.video);
		var canvas = this.$con.find('canvas')[0];
		var ctx = canvas.getContext("2d");
		this.ctime = 0;
		this.lastTime;
		var ua = navigator.userAgent;
		//if(/(iPhone|iPod|iPad)/.test(ua)) {
		    this.video.addEventListener('canplay',()=>{
			    this.emit('ready');
		        this.lastTime = Date.now();
		        setInterval(()=>{
			        if(!this.isPlay) return;
		            var curTime = Date.now();
		            var diff = Date.now() - this.lastTime;
		            this.lastTime = curTime;
		            this.ctime += diff/1000;
		            this.video.currentTime = this.ctime;
		            
		            ctx.drawImage(this.video, 0, 0, vW, vH);
		            if(this.video.duration <= this.video.currentTime){
		                this.ctime = 0;
		            }
		        }, 1000/30);
		    },false);
		//}
		this.video.src = src;
		this.video.load();
		
		Browser.addResizeHandler(this.resize,this);
		this.resize();
	}
	
	replay(){
		this.lastTime = Date.now();
		this.video.currentTime = this.ctime = 0;
		this.isPlay = true;
	}
	
	play(){
		this.isPlay = true;
	}
	
	stop(){
		this.isPlay = false;
	}
	
	resize(){
		let w,h,top,left;
		let initW = this.$con.data('width');
		let initH = this.$con.data('height');
		let wW = Browser.windowWidth;
		let wH = Browser.windowHeight;
		if(wH > wW) wH = wW;
		let rate1 = wW / wH;
		let rate2 = initW/initH;
		if(rate1 > rate2){
			w = wW;
			h = initH * wW/initW;
			top = -(h - wH)>>1;
			left = 0;
			
		} else {
			w = initW * wH/initH;
			h = wH;
			top = 0;
			left = -(w - wW)>>1;
		}
		w = Math.ceil(w);
		h = Math.ceil(h);
		top = Math.ceil(top);
		left = Math.ceil(left);
		
		w += 2;
		h += 2;
		top -=1;
		left -=1;
		this.$canvas.css({width:w,height:h,top:top , left:left});
		//this.$video.css({width:w,height:h});
	}

}

export default VideoCanvas;


// WEBPACK FOOTER //
// ./js/video/videocanvas.js